import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a56d59c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fullscreen-spin"
}
const _hoisted_2 = { class: "spin" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1))
const _hoisted_4 = { class: "text" }


export default /*#__PURE__*/_defineComponent({
  __name: 'FullscreenSpin',
  props: {
  loading: {
    type: Boolean,
    default: false,
  },
  tip: {
    type: String,
    default: '',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, _toDisplayString(__props.tip), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})